import { render } from "./Groups.vue?vue&type=template&id=ef71ab54&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=ef71ab54&lang=less&scoped=true"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef71ab54"],['__file',"backend/vue/cacheclear/Groups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef71ab54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef71ab54', __exports__)) {
    api.reload('ef71ab54', __exports__)
  }
  
  module.hot.accept("./Groups.vue?vue&type=template&id=ef71ab54&scoped=true", () => {
    api.rerender('ef71ab54', render)
  })

}


export default __exports__